// src/services/ApiService.ts — barrel export for backward compatibility
//
// All domain-specific logic has been split into modules under ./api/.
// This file re-exports everything so existing imports continue to work:
//   import { ApiService } from '../../services/ApiService.ts'

import { authApi } from './api/auth.ts';
import { projectsApi } from './api/projects.ts';
import { peopleApi } from './api/people.ts';
import { relationshipsApi } from './api/relationships.ts';
import { sourcesApi } from './api/sources.ts';
import { eventsApi } from './api/events.ts';
import { placesApi } from './api/places.ts';
import { mediaApi } from './api/media.ts';
import { tasksApi } from './api/tasks.ts';
import { storiesApi } from './api/stories.ts';
import { collaborationApi } from './api/collaboration.ts';
import { notesApi } from './api/notes.ts';
import { gedcomApi } from './api/gedcom.ts';
import { auditApi } from './api/audit.ts';
import { reportsApi } from './api/reports.ts';
import { historyApi } from './api/history.ts';
import { supportApi } from './api/support.ts';
import { organizationsApi } from './api/organizations.ts';
import { onboardingApi } from './api/onboarding.ts';
import { archivesApi } from './api/archives.ts';
import { clientsApi } from './api/clients.ts';
import { bureauApi } from './api/bureau.ts';

// Re-export shared infrastructure that other files import directly
export {
  ApiError,
  initializeBackendConfig,
  startProactiveRefresh,
  ensureSession,
  refreshIfNeeded,
  getErrorMessage,
} from './api/base.ts';

export const ApiService = {
  ...authApi,
  ...projectsApi,
  ...peopleApi,
  ...relationshipsApi,
  ...sourcesApi,
  ...eventsApi,
  ...placesApi,
  ...mediaApi,
  ...tasksApi,
  ...storiesApi,
  ...collaborationApi,
  ...notesApi,
  ...gedcomApi,
  ...auditApi,
  ...reportsApi,
  ...historyApi,
  ...supportApi,
  ...organizationsApi,
  ...onboardingApi,
  ...archivesApi,
  ...clientsApi,
  ...bureauApi,
};
